import { IonImg } from '@ionic/react';
import { useMemo } from 'react';

import BackgroundPattern from '@/assets/bg-pattern-select-data-file.png';

import styles from './SelectDataFileActionSection.module.css';

import { Button } from '../Button';

interface SelectDataFileActionSectionProps {
  description: string;
  title: string;
  buttonText: string;
  buttonOnclick?: () => void;
}

export const SelectDataFileActionSection = ({
  description,
  title,
  buttonText,
  buttonOnclick,
}: SelectDataFileActionSectionProps) => {
  const descriptionWithHtml = useMemo(() => {
    // Replace *text* with <strong class="styles.strong">text</strong>
    let html = description.replace(/\*([^*]+)\*/g, (_, match) => `<strong>${match}</strong>`);

    // Replace _text_ with <i class="styles.italic">text</i>
    html = html.replace(/_([^_]+)_/g, (_, match) => `<i >${match}</i>`);
    return html;
  }, [description]);
  return (
    <>
      <div className={styles.panel}>
        <div className={styles.textContainer}>
          <h1 className={styles.title}>{title}</h1>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: descriptionWithHtml,
            }}
          />
        </div>
        <Button onClick={buttonOnclick} size='large' variant='primary'>
          {buttonText}
        </Button>

        <IonImg className={styles.backgroundImage} src={BackgroundPattern} />
      </div>
    </>
  );
};
